import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./auth/slice";
import userReducer from "./user/slice";
import branchReducer from "./branch/slice";
import topicsReducer from "./topics/slice";
import chatsReducer from "./chats/slice";
import posterReducer from "./poster/slice";
import { websocketMiddleware } from "./chats/middleware/websocketMiddleware";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    user: userReducer,
    branch: branchReducer,
    topics: topicsReducer,
    chats: chatsReducer,
    posters: posterReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(websocketMiddleware),
});
